import { useState, useEffect } from "react";
import bg from "assests/Products/bg.jpg";
import Container from "Components/Container/Container";
import { Link } from "react-router-dom";
import LoadingScreen from "Components/RequestHandler/LoadingScreen";
import useFetch from "Hooks/useFetch.js";
import IsError from "Components/RequestHandler/IsError";

import ProductsLanding from "./ProductsLanding";

const ProductsMainPage = () => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData, error } = useFetch();

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      const data = await fetchData("brands");
      setData(data);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (isLoading) return <LoadingScreen />;
  if (error || isError) return <IsError />;
  if (data) {
    return (
      <main className=" relative">
        <section
          style={{ backgroundImage: `url(${bg})` }}
          className="h-[40vh] background normal-section-80  relative"
        >
          <Container className=" h-full  flex items-center justify-center relative">
            <div className="relative z-[200] ">
              <div className="text-2xl justify-center text-[#808080] flex items-center  gap-x-2">
                <Link to={"/"} className="hover:underline">
                  Home
                </Link>
                <span>|</span>
                <p> Brands</p>
              </div>

              <h2 className="text-white text-center text-4xl sm:text-6xl md:text-7xl lg:text-8xl bebas uppercase mt-2 tracking-[12px]">
                Brands
              </h2>
              <div className="bg-white h-[3px] mx-auto w-[4rem]"></div>
            </div>
            <div className="absolute left-1/2 -translate-x-1/2 bottom-24 hidden xl:block">
              <div class="mouse"></div>
            </div>
          </Container>
        </section>
        <ProductsLanding data={data} />
      </main>
    );
  }
};

export default ProductsMainPage;
